import { Component, Vue } from 'nuxt-property-decorator';

@Component({
    components: {
        pagination: require('~/components/catalog/pagination').default,
        pic: require('~/components/common/image').default,
    }
})
export default class NewsPageComponent extends Vue {

    public text: string = null;
    page!: number;
    news: any[];

    public head() {
        return {
            title: `Новости холдинга ТриЯ${this.page > 1 ? ` страница ${this.page}` : ''}`,
            meta: [
                { vmid: 'description', name: 'description', content: this.page > 1 ? `Страница новостей ${this.page}` : 'Свежие новости холдинга ТриЯ.' },
            ],
        };
    }

    public async asyncData({ store, route }) {

        const page = route.query.page ? Number(route.query.page) : 1;

        const data = await store.dispatch('RestRequest', {
            url: '/news',
            params: {
                page
            }
        });

        return {...data, page};
    }

    public setPage(page) {
        this.page = page;

        if (page) {
            this.$router.replace({
                query: {}
            })
        } else {
            this.$router.replace({
                query: {page}
            })
        }

        return this.loadMore();
    }

    public async loadMore() {

        const data = await this.$store.dispatch('RestRequest', {
            url: '/news',
            params: {
                page: this.page
            }
        });

        this.news = data.news;
    }

    get h1() {
        return this.page > 1 ? `Новости стр ${this.page}` : 'Новости компании';
    }
}
